var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    width: 8.994,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m528.305 537a.209.209 0 0 1 -.064-.155v-.437a2.458 2.458 0 0 1 .273-1.193 2.784 2.784 0 0 1 .656-.819q.382-.319 1-.738a5.683 5.683 0 0 0 1.01-.765 1.086 1.086 0 0 0 .319-.783.908.908 0 0 0 -.382-.773 1.675 1.675 0 0 0 -1.02-.282 1.75 1.75 0 0 0 -1.1.318 1 1 0 0 0 -.41.829v.2c0 .133-.073.2-.219.2l-2.585-.11a.2.2 0 0 1 -.155-.072.242.242 0 0 1 -.064-.164v-.054a3.6 3.6 0 0 1 .583-2.03 3.866 3.866 0 0 1 1.63-1.375 6.114 6.114 0 0 1 4.715-.036 3.518 3.518 0 0 1 1.53 1.284 3.456 3.456 0 0 1 .537 1.921 3.051 3.051 0 0 1 -.291 1.393 3.152 3.152 0 0 1 -.7.938 9.19 9.19 0 0 1 -1.047.783 5.768 5.768 0 0 0 -.947.737 1.068 1.068 0 0 0 -.31.773v.255a.214.214 0 0 1 -.064.155.212.212 0 0 1 -.155.063h-2.585a.208.208 0 0 1 -.155-.063zm.218 3.859a1.575 1.575 0 0 1 1.12-2.721 1.558 1.558 0 0 1 1.138.437 1.535 1.535 0 0 1 .446 1.146 1.553 1.553 0 0 1 -.446 1.129 1.638 1.638 0 0 1 -2.258.009z",
    fill: "#3c2f87",
    transform: "translate(-525.564 -528.309)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b4de4d09b7cd0562abb4324000415127.svg";
export { ForwardRef as ReactComponent };